import { render, staticRenderFns } from "./HeaderGuests.vue?vue&type=template&id=03550feb&"
import script from "./HeaderGuests.vue?vue&type=script&lang=js&"
export * from "./HeaderGuests.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGuests.vue?vue&type=style&index=0&id=03550feb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports